import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faSun, faMoon } from "@fortawesome/free-solid-svg-icons";

import "../assets/Header.scss";

export default function Header({ onToggleNavigation, navToggleRef }) {
  const [theme, setTheme] = useState("dark");

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  };

  return (
    <div className="header">
      <div className="header__content">
        <div
          className="header__navigationTrigger"
          onClick={onToggleNavigation}
          ref={navToggleRef}
        >
          <FontAwesomeIcon icon={faBars} />
        </div>
        <div className="header__right">
          <div className="header__themeToggle" onClick={toggleTheme}>
            <div
              className={`header__themeToggleSlider ${
                theme === "light" ? "header__themeToggleSlider--light" : "header__themeToggleSlider--dark"
              }`}
            >
              <FontAwesomeIcon icon={faSun} className="header__themeToggleIcon header__themeToggleIcon--sun" />
              <FontAwesomeIcon
                icon={faMoon}
                className="header__themeToggleIcon header__themeToggleIcon--moon"
              />
              <div className="header__themeToggleHandle" />
            </div>
          </div>
          <div className="header__avatar">
            <img src="/images/pete.png" alt="Peter Lawlor" />
          </div>
        </div>
      </div>
    </div>
  );
}
